// Mirrors apps/ni-server/server/src/config/regions.ts: the code the server
// answers with (HTTP 409) when the account belongs to another regional stack.
export const WRONG_REGION_CODE = 'WRONG_REGION';
